/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { control, DomUtil, type Map as LeafletMap } from 'leaflet';
import { useEffect } from 'react';

function useLegendControl(map: LeafletMap, html?: string) {
  useEffect(() => {
    if (!html) return; // Don't show a legend if we don't have anything in it
    const legend = control.layers(undefined, undefined, { position: 'bottomright' });
    legend.onAdd = () => {
      const container = DomUtil.create('div', 'info legend collapsible collapsed');
      const header = DomUtil.create('div', 'legend-header', container);
      const title = DomUtil.create('span', 'legend-title', header);
      title.innerHTML = 'Legend';
      const toggle = DomUtil.create('button', 'legend-toggle', header);
      toggle.innerHTML = '+';
      const content = DomUtil.create('div', 'legend-content', container);
      content.innerHTML = html;
      toggle.addEventListener('click', () => {
        const collapsed = container.classList.toggle('collapsed');
        toggle.innerHTML = collapsed ? '+' : '−';
      });
      return container;
    };
    legend.addTo(map);
    return () => {
      legend.remove();
    };
  }, [map, html]);
}

export default useLegendControl;
